import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { compose, withStateHandlers, withHandlers } from 'recompose';
var sweetAlertConfirm = function sweetAlertConfirm(wrappedFunctionName) {
  var _withStateHandlers, _withStateHandlers2, _withHandlers;
  if (!wrappedFunctionName || typeof wrappedFunctionName !== 'string' || wrappedFunctionName.length <= 0) {
    console.error('ERROR: "wrappedFunctionName" should be a string with the same name of the function method to be called');
    return null;
  }
  var stateAlertName = "".concat(wrappedFunctionName, "AlertShow");
  var stateAlertArgs = "".concat(wrappedFunctionName, "AlertArgs");
  var showAlertFunction = "showAlertFor".concat(wrappedFunctionName);
  var hideAlertFunction = "hideAlertFor".concat(wrappedFunctionName);
  var confirmFunctionName = "confirm".concat(wrappedFunctionName);
  var cancelFunctionName = "cancel".concat(wrappedFunctionName);
  return compose(withStateHandlers((_withStateHandlers = {}, _defineProperty(_withStateHandlers, stateAlertName, false), _defineProperty(_withStateHandlers, stateAlertArgs, null), _withStateHandlers), (_withStateHandlers2 = {}, _defineProperty(_withStateHandlers2, showAlertFunction, function () {
    return function () {
      var _ref;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ref = {}, _defineProperty(_ref, stateAlertName, true), _defineProperty(_ref, stateAlertArgs, args), _ref;
    };
  }), _defineProperty(_withStateHandlers2, hideAlertFunction, function () {
    return function () {
      var _ref2;
      return _ref2 = {}, _defineProperty(_ref2, stateAlertName, false), _defineProperty(_ref2, stateAlertArgs, null), _ref2;
    };
  }), _withStateHandlers2)), withHandlers((_withHandlers = {}, _defineProperty(_withHandlers, wrappedFunctionName, function (_ref3) {
    var showAlert = _ref3[showAlertFunction];
    return function () {
      showAlert.apply(void 0, arguments);
    };
  }), _defineProperty(_withHandlers, cancelFunctionName, function (_ref4) {
    var hideAlert = _ref4[hideAlertFunction];
    return function () {
      hideAlert();
    };
  }), _defineProperty(_withHandlers, confirmFunctionName, function (_ref5) {
    var hideAlert = _ref5[hideAlertFunction],
      args = _ref5[stateAlertArgs],
      func = _ref5[wrappedFunctionName];
    return function () {
      hideAlert();
      if (args) {
        return func.apply(void 0, _toConsumableArray(args));
      }
      return func();
    };
  }), _withHandlers)));
};
export default sweetAlertConfirm;